import React, { useState } from 'react';
import { Box } from '@mui/material'
import { KeyboardArrowUpRounded } from '@mui/icons-material';
import colors from '../../theme/colors'

const ButtonScrollToTop = () => {
    const [isVisible, setIsVisible] = useState(false);

    const handleScroll = () => {
        const scrollPosition = window.pageYOffset;
        if (scrollPosition > 300) {
            setIsVisible(true);
        } else {
            setIsVisible(false);
        }
    };

    const handleClick = () => {
        window.scrollTo({
            behavior: "smooth",
            top: 0
        });
    };

    window.addEventListener('scroll', handleScroll);

    return (
        <>
            {/* Colocar en el top de la pagina */}
            <Box id="back-to-top-anchor"></Box>

            <button
                onClick={handleClick}
                style={{
                    display: isVisible ? 'block' : 'none',
                    position: 'fixed',
                    bottom: '20px',
                    right: '30px',
                    zIndex: '99',
                    border: '1px solid '+colors.textMain,
                    outline: 'none',
                    backgroundColor: colors.primary,
                    color: colors.textMain,
                    cursor: 'pointer',
                    padding: '1em',
                    borderRadius: '1em',
                }}
            >
                <KeyboardArrowUpRounded sx={{color: colors.textMain}} fontSize='large'/>
            </button>
        </>
    );
};
export default ButtonScrollToTop;